const courseData = [
  {
    id_curso: "naildesign",
    title: "Nail Designer",
    modalities: [
      {
        name: "EAD",
        title: "Curso Online - EAD",
        details: [
          { text: "Acesso vitalício a 2 apostilas digitais 100% online.", available: true },
          { text: "14 videoaulas teóricas e práticas.", available: true },
          { text: "Certificado de conclusão garantido.", available: true },
          { text: "Orientações para atendimento profissional.", available: true },
          { text: "Acesso à comunidade de networking.", available: false },
          { text: "Aulas presenciais teóricas e práticas nos estúdios profissionais da Academia Girassol.", available: false },
          { text: "60h de aulas práticas garantidas no certificado.", available: false },
          { text: "Suporte exclusivo de instrutor profissional.", available: false }
        ],
        price: "em até 3x de R$99,90/Mês ou R$ 299,90 à vista",
        course_link: "https://academiagirassol.hotmart.host/nail-designer",
        btn_link: "https://hotm.art/DesignUnhasGirassol"
      },
      {
        name: "Presencial",
        title: "Curso Presencial",
        details: [
          { text: "Acesso vitalício a 2 apostilas digitais 100% online.", available: true },
          { text: "14 videoaulas teóricas e práticas.", available: true },
          { text: "Certificado de conclusão garantido.", available: true },
          { text: "Orientações para atendimento profissional.", available: true },
          { text: "Acesso à comunidade de networking.", available: true },
          { text: "Aulas presenciais teóricas e práticas nos estúdios profissionais da Academia Girassol.", available: true },
          { text: "60h de aulas práticas garantidas no certificado.", available: true },
          { text: "Suporte exclusivo de instrutor profissional.", available: true }
        ],
        price: "em até 6x de R$133,90/Mês ou R$ 799,00 à vista",
        course_link: "https://academiagirassol.hotmart.host/nail-designer",
        btn_link: "https://pay.hotmart.com/W92532436G?off=1dxtukrk&checkoutMode=10"
      }
    ]
  },
  {
    id_curso: "browdesign",
    title: "Brow Designer",
    modalities: [
      {
        name: "EAD",
        title: "Curso Online - EAD",
        details: [
          { text: "Acesso vitalício a apostila digital 100% online.", available: true },
          { text: "5 videoaulas teóricas e práticas.", available: true },
          { text: "Certificado de conclusão garantido.", available: true },
          { text: "Orientações para atendimento profissional.", available: true },
          { text: "Acesso à comunidade de networking.", available: false },
          { text: "Aulas presenciais teóricas e práticas nos estúdios profissionais da Academia Girassol.", available: false },
          { text: "16h de aulas práticas garantidas no certificado.", available: false },
          { text: "Suporte exclusivo de instrutor profissional.", available: false }
        ],
        price: "em até 3x de R$69,99/Mês ou R$ 199,90 à vista",
        course_link: "https://academiagirassol.hotmart.host/brow-designer",
        btn_link: "https://hotm.art/DesignBrowGirassol"
      },
      {
        name: "Presencial",
        title: "Curso Presencial",
        details: [
          { text: "Acesso vitalício a apostila digital 100% online.", available: true },
          { text: "5 videoaulas teóricas e práticas.", available: true },
          { text: "Certificado de conclusão garantido.", available: true },
          { text: "Orientações para atendimento profissional.", available: true },
          { text: "Acesso à comunidade de networking.", available: true },
          { text: "Aulas presenciais teóricas e práticas nos estúdios profissionais da Academia Girassol.", available: true },
          { text: "16h de aulas práticas garantidas no certificado.", available: true },
          { text: "Suporte exclusivo de instrutor profissional.", available: true }
        ],
        price: "em até 3x de R$133,99/Mês ou R$ 399,90 à vista",
        course_link: "https://academiagirassol.hotmart.host/brow-designer",
        btn_link: "https://hotm.art/DesignBrowGirassol"
      }
    ]
  },
  {
    id_curso: "makeup",
    title: "Maquiagem Profissional",
    modalities: [
      {
        name: "EAD",
        title: "Curso Online - EAD",
        details: [
          { text: "Acesso vitalício ao conteúdo digital 100% online.", available: true },
          { text: "Aprenda desde técnicas básicas até as mais avançadas para pele, olhos e boca.", available: true },
          { text: "Certificado de conclusão garantido.", available: true },
          { text: "Orientações para atendimento profissional.", available: true },
          { text: "Acesso à comunidade de networking.", available: false },
          { text: "Aulas presenciais teóricas e práticas nos estúdios profissionais da Academia Girassol.", available: false },
          { text: "20h de aulas práticas garantidas no certificado.", available: false },
          { text: "Suporte exclusivo de instrutor profissional.", available: false },
        ],
        price: "em até 3x de R$69,90/Mês ou R$ 199,90 à vista",
        course_link: "https://academiagirassol.hotmart.host/maquiagem-profissional",
        btn_link: "https://hotm.art/MaquiagemGirassol"
      },
      {
        name: "Presencial",
        title: "Curso Presencial",
        details: [
          { text: "Acesso vitalício ao conteúdo digital 100% online.", available: true },
          { text: "Aprenda desde técnicas básicas até as mais avançadas para pele, olhos e boca.", available: true },
          { text: "Certificado de conclusão garantido.", available: true },
          { text: "Orientações para atendimento profissional.", available: true },
          { text: "Acesso à comunidade de networking.", available: true },
          { text: "Aulas presenciais teóricas e práticas nos estúdios profissionais da Academia Girassol.", available: true },
          { text: "20h de aulas práticas garantidas no certificado.", available: true },
          { text: "Suporte exclusivo de instrutor profissional.", available: true }
        ],
        price: "em até 3x de R$133,90/Mês ou R$ 399,90 à vista",
        course_link: "https://academiagirassol.hotmart.host/maquiagem-profissional",
        btn_link: "https://hotm.art/MaquiagemGirassol"
      }
    ]
  }
];

export default courseData;
